import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, last, map, Observable, Subscription, switchMap, tap } from 'rxjs';
import { CommonModule } from '@angular/common';

import { PatientSchemaTableComponent } from '../../../shared/components/schema-tables/patient-schema-table/patient-schema-table.component';
import { SessionStoreRepository } from '../../../shared/repositories/session.repository';
import { SchemaRepository } from '../../../shared/repositories/schema.repository';
import { calculatePaginationPages } from '../../../shared/helpers/pagination-helper';
import { Schema } from '../../../shared/models/schema.model';
import { LoadingSpinnerBorderComponent } from "../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";

@Component({
    selector: 'others-historical-schema-list',
    imports: [CommonModule, PatientSchemaTableComponent, LoadingSpinnerBorderComponent],
    templateUrl: './others-historical-schema-list.component.html',
    styleUrl: './others-historical-schema-list.component.scss'
})
export class OthersHistoricalSchemaListComponent implements OnInit, OnDestroy {
    private readonly sessionService = inject(SessionStoreRepository);
    private readonly schemaRepository = inject(SchemaRepository);

    private subscription = new Subscription();

    schemas$ = this.schemaRepository.patientOtherCompletedSchemas$;
    isPatient$ = this.sessionService.isPatient$;
    isLoading$ = new BehaviorSubject<boolean>(true).asObservable();

    paginatedSchemas$ = new Observable<Schema[]>;
    tabKey: string = "othershistorical";

    currentPage: number = 1;
    perPage: number = 10;
    lastPage: number = 1;
    pages: number = 1;
    total: number = 0;
    pagesIntervalSize: number = 5;
    visiblePaginationPages: number[] = [];

    ngOnInit() {
        this.subscription.add(
            this.schemaRepository.getPatientOtherCompletedSchemas$().pipe(
                switchMap(() => this.schemaRepository.patientOtherCompletedSchemas$),
                tap(schemas => {
                    this.total = schemas.length;
                    this.lastPage = Math.ceil(this.total / this.perPage);
                    this.pages = Math.ceil(this.total / this.perPage);
                }),
                map(schemas => {
                    const data = schemas;
                    const paginatedData = data.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
                    return new BehaviorSubject({ paginatedData }).asObservable();
                })
            ).subscribe(result => {
                this.paginatedSchemas$ = result.pipe(map(x => x.paginatedData));
                this.isLoading$ = this.schemaRepository.patientOtherCompletedSchemasIsLoading$;
                this.visiblePaginationPages = calculatePaginationPages(this.currentPage, this.lastPage, this.pages, this.pagesIntervalSize);
            })
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

}